import React, {
  PropsWithChildren, createContext, useContext, useMemo,
} from 'react';

interface IGroupContextValue {
  isInvalid: boolean;
}

const initialValue:IGroupContextValue = { isInvalid: false };

const GroupContext = createContext<IGroupContextValue>(initialValue);

export const useGroupContext = () => {
  return useContext(GroupContext);
};

interface IGroupContextProviderProps extends PropsWithChildren {
  isInvalid: boolean;
}

export const GroupContextProvider = ({
  isInvalid,
  children,
}: IGroupContextProviderProps) => {
  const value = useMemo(() => {
    return { isInvalid };
  }, [isInvalid]);

  return (
    <GroupContext.Provider value={value}>
      {children}
    </GroupContext.Provider>
  );
};
